import React from 'react';
import './ExpandMenu.scss';
import UlList from '../../Atoms/UlList';
import ImgTag from '../../Atoms/ImgTag';

const insertToggleImage = (props) => {
    return (
        <ImgTag
            className = {props.toggleImgClass}
            src = {props.toggleImgSrc}
            alt = 'Down arrow'
            onClick = {props.oncontainerTitleClicked}
        />
    );
}

const ExpandMenu = (props) => {
    return (
        <div className = {props.containerClass}>
            <h4 
                className = {props.containerTitleClass}
                onClick = {props.oncontainerTitleClicked}
            >
                {props.containerTitleValue}
            </h4>
            {props.toggleImgSrc ? insertToggleImage(props) : ''}
            <UlList 
                listContainerClass = {props.listContainerClass}
                listItemClass = {props.listItemClass}
                listContainerProps = {props.listContainerProps}
                listItems = {props.listItems}
                listItemTitle = {props.listItemTitle}
                onListItemClick = {props.onListItemClick}
            />
        </div>
    );
}

export default ExpandMenu;